import cookies from "react-cookies";

import { AUTH_TOKEN_COOKIES_KEY } from "./constants";

import { getDomain } from "modules/core/utils/helpers";

import { coreRoutesConstants } from "modules/core/routes/routesConstants";
import { experimentsPrivateRoutesConstants } from "modules/experiments/routes/private/routesConstants";
import { ideasPrivateRoutesConstants } from "modules/ideas/routes/private/routesConstants";
import { researchPrivateRoutesConstants } from "modules/research/routes/private/routesConstants";
import { insightsPrivateRoutesConstants } from "modules/insights/routes/private/routesConstants";
import { reportsPrivateRoutesConstants } from "modules/reports/routes/private/routesConstants";
import { collaborationPrivateRoutesConstants } from "modules/collaboration/routes/private/routesConstants";

import { ProfileDefaultView } from "modules/user/types/entities";
import { governancePrivateRoutesConstants } from "modules/governance/routes/private/routesConstants";

export const getAuthToken = (): string | undefined =>
  cookies.load(AUTH_TOKEN_COOKIES_KEY);

export const setAuthToken = (token: string) => {
  const domain = "." + getDomain();

  cookies.save(AUTH_TOKEN_COOKIES_KEY, token, {
    path: "/",
    domain
  });
};

export const removeAuthToken = () => {
  const domain = "." + getDomain();

  cookies.remove(AUTH_TOKEN_COOKIES_KEY, { path: "/", domain });
  cookies.remove(AUTH_TOKEN_COOKIES_KEY, { path: "/" });
};

export const getSSOSubdomains = (): string[] => {
  const allowedSubdomains = [
    "mrq",
    "gsk",
    "hm",
    "coop",
    "winnie",
    "brendin",
    "effectivetest",
    "digitaltonic",
    "asdf"
  ];

  return allowedSubdomains.filter(subdomain => {
    const isEnabled =
      import.meta.env[`REACT_APP_${subdomain.toUpperCase()}_SSO_ENABLED`] ===
      "true";
    return isEnabled;
  });
};

export const getPreferredRedirectUrl = (
  view: ProfileDefaultView | null,
  projectId: string | null
): string => {
  projectId ||= "all";

  switch (view) {
    case "experiments":
      return experimentsPrivateRoutesConstants.root.href(projectId);

    case "ideas":
      return ideasPrivateRoutesConstants.root.href(projectId);

    case "research":
      return researchPrivateRoutesConstants.root.href(projectId);

    case "project_stats":
      return insightsPrivateRoutesConstants.project_stats.href(projectId);

    case "people_stats":
      return governancePrivateRoutesConstants.people_stats.href(projectId);

    case "reports":
      return reportsPrivateRoutesConstants.root.href(projectId);

    case "to_do_lists":
      return collaborationPrivateRoutesConstants.todos.href(projectId);

    case "brainstorm_ideas":
      return collaborationPrivateRoutesConstants.brainstorming.href(projectId);

    case "roadmap":
      return insightsPrivateRoutesConstants.roadmap.href(projectId);

    case "query_engine":
      return insightsPrivateRoutesConstants.query_engine.href(projectId);

    default:
      return coreRoutesConstants.dashboard.href(projectId);
  }
};
